import { EditorState } from 'draft-js';

import { ITimestampsModel, ObjectId } from './base';

import { IUser } from '.';

export const SecondaryNarrativeTypes = {
  DETECTIVE: 'Detective',
  DISPATCHER: 'Dispatcher',
  OFFICER: 'Officer',
  SUPPLEMENT: 'Supplement',
};

export const NarrativeTypes = {
  PRIMARY: 'Primary',
  ...SecondaryNarrativeTypes,
};

export type INarrativeType = keyof typeof NarrativeTypes;

export interface INarrative extends ITimestampsModel, ObjectId {
  kaseId: string;
  cfsId?: string;
  arresteeId?: string;
  content: {
    entityMap: any;
    text: any;
  };
  createdBy: IUser;
  title: string;
  type: INarrativeType;
}

export type INarrativeRequest = Pick<INarrative, 'title' | 'type' | '_id'>;
export interface INarrativeForm extends INarrativeRequest {
  content: EditorState;
}
